import React from 'react';
import Skeleton from '../../../utils/components/Skeleton';

export default function PlanSkeleton() {
  return (
    <>
      <div className="plan--selected" style={{marginBottom: "50px"}}>
        <div className="plan--side">
          <Skeleton containerClass="plan--info" />
          <Skeleton containerClass="plan--features" />
        </div>
        <div className="addons--side">
          <Skeleton containerClass="plan--addons" />
          <Skeleton containerClass="subtotal" />
        </div>
      </div>
    </>
  )
}